import * as React from 'react';

import {
  CcmCampaignCreateCreatorfull,
  CcmCampaignCreateCreatorless
} from 'modules/campaigns/components/ccm/create';
import CcmCampaignCreateHeader from '../header/CcmCampaignCreateHeader';

import type { CcmCampaignType } from 'modules/campaigns/components/ccm/types';

type Props = {
  campaignType: CcmCampaignType,
  organizationId: number,
  brandProfileId: number
};

const CcmCampaignCreateContainer = ({
  campaignType,
  organizationId,
  brandProfileId
}: Props): JSX.Element => (
  <div className="ccm-campaign-create-container">
    {campaignType === 'creatorfull' ? (
      <CcmCampaignCreateCreatorfull
        pageHeading={(
          <CcmCampaignCreateHeader brandProfileId={brandProfileId} />
        )}
        organizationId={organizationId}
        brandProfileId={brandProfileId}
      />
    ) : null}
    {campaignType === 'creatorless' ? (
      <CcmCampaignCreateCreatorless
        pageHeading={(
          <CcmCampaignCreateHeader brandProfileId={brandProfileId} />
        )}
        organizationId={organizationId}
        brandProfileId={brandProfileId}
      />
    ) : null}
  </div>
);

export default CcmCampaignCreateContainer;
